<template>
  <div class="review-item">
    <div class="level">
      <div class="level-left">
        <mc-challenge-rating-input
          v-model="review.rating"
          label="Ratings"
          disabled
        />
      </div>
      <div class="level-right">
        <b-field label="Score">
          <p class="title is-6">
            {{ review.rating * weight }}/{{ 2 * totalWeigth }}
          </p>
        </b-field>
      </div>
    </div>
    <b-field label="Comment">
      <p class="subtitle is-6">{{ review.comment || 'no comments' }}</p>
    </b-field>
  </div>
</template>

<script>
export default {
  props: {
    review: { required: true, type: Object },
    weight: { required: true, type: Number },
    totalWeigth: { required: true, type: Number }
  }
};
</script>
